export default "__VITE_ASSET__BkYaSJYB__"